"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogDataStore = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var uuid_1 = require("uuid");
var DB_KEY = "data";
var MAX_STORE_LEN = 400;
var DEFAULT_QUANTITY = 200;
var LogDataStore = /** @class */ (function () {
    function LogDataStore() {
    }
    LogDataStore.prototype.init = function (appName) {
        this.storageService.init({
            name: appName,
            storeName: "behavior4",
        });
    };
    LogDataStore.prototype.queryAllRecords = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, transformed, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.storageService.getItem(DB_KEY)];
                    case 1:
                        data = _a.sent();
                        if (!data) {
                            return [2 /*return*/, []];
                        }
                        transformed = this.transformFieldsService.toFullName(data);
                        return [2 /*return*/, transformed];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.queryByCondition = function (predicate) {
        return __awaiter(this, void 0, void 0, function () {
            var records, data, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.queryAllRecords()];
                    case 1:
                        records = _a.sent();
                        data = records.filter(predicate);
                        return [2 /*return*/, data];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.insertOrUpdateRecords = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var records_1, newRecords_1, completeRecords, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.queryAllRecords()];
                    case 1:
                        records_1 = _a.sent();
                        newRecords_1 = [];
                        data.forEach(function (item, index) {
                            var exists = records_1.filter(function (r) { return r.primaryKey === item.primaryKey; });
                            if (exists.length === 1) {
                                var recordIndex = records_1.findIndex(function (r) { return r.primaryKey === item.primaryKey; });
                                // 更新数据
                                records_1[recordIndex] = item;
                            }
                            else if (exists.length > 1) {
                                // 出现异常数据，有多个 key 相同，更新他们的 key
                                exists.forEach(function (item) {
                                    item.primaryKey = (0, uuid_1.v4)();
                                });
                            }
                            else {
                                // 新增数据，增加 primaryKey
                                item.primaryKey = (0, uuid_1.v4)();
                                newRecords_1[index] = item;
                            }
                        });
                        completeRecords = records_1.concat(newRecords_1);
                        // 大于 400 条数据，则保留最近的 200 条
                        if (completeRecords.length > MAX_STORE_LEN) {
                            completeRecords = completeRecords.slice(completeRecords.length - DEFAULT_QUANTITY, completeRecords.length);
                        }
                        return [4 /*yield*/, this.setRecords(completeRecords)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.insertRecords = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var records, completeRecords, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.queryAllRecords()];
                    case 1:
                        records = _a.sent();
                        data.forEach(function (item) {
                            item.primaryKey = (0, uuid_1.v4)();
                        });
                        completeRecords = records.concat(data);
                        // 大于 400 条数据，则保留最近的 200 条
                        if (completeRecords.length > MAX_STORE_LEN) {
                            completeRecords = completeRecords.slice(completeRecords.length - DEFAULT_QUANTITY, completeRecords.length);
                        }
                        return [4 /*yield*/, this.setRecords(completeRecords)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_4 = _a.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.setRecords = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var transformed, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        transformed = this.transformFieldsService.toAbbr(data);
                        return [4 /*yield*/, this.storageService.setItem(DB_KEY, JSON.stringify(transformed))];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Promise.reject(error_5)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.batchUpdate = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var records_2, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.queryAllRecords()];
                    case 1:
                        records_2 = _a.sent();
                        data.forEach(function (item) {
                            var recordIndex = records_2.findIndex(function (r) { return r.primaryKey === item.primaryKey; });
                            if (recordIndex > -1) {
                                records_2[recordIndex] = item;
                            }
                        });
                        return [4 /*yield*/, this.setRecords(records_2)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_6 = _a.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.removeRecords = function (quantity) {
        if (quantity === void 0) { quantity = DEFAULT_QUANTITY; }
        return __awaiter(this, void 0, void 0, function () {
            var records, keepRecords, rest, reservedRecords, error_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.queryAllRecords()];
                    case 1:
                        records = _a.sent();
                        keepRecords = records
                            .slice(0, quantity)
                            .filter(function (r) { return !(r.shouldDelete && r.isComplete && !r.isUploading); });
                        rest = records.slice(quantity, records.length);
                        reservedRecords = rest.concat(keepRecords);
                        return [4 /*yield*/, this.setRecords(reservedRecords)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_7 = _a.sent();
                        return [2 /*return*/, Promise.reject()];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    LogDataStore.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.storageService.clear();
                return [2 /*return*/];
            });
        });
    };
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.IStorageService),
        __metadata("design:type", Object)
    ], LogDataStore.prototype, "storageService", void 0);
    __decorate([
        (0, inversify_1.inject)(event_tracking_core_1.TYPES.ITransformFieldsService),
        __metadata("design:type", Object)
    ], LogDataStore.prototype, "transformFieldsService", void 0);
    LogDataStore = __decorate([
        (0, inversify_1.injectable)()
    ], LogDataStore);
    return LogDataStore;
}());
exports.LogDataStore = LogDataStore;
